<style>
  img {
    width: 100%;
    height: auto;
  }

  article {
    flex-direction: row;
  }

  @media (max-width: 40rem) {
    article {
      margin-left: auto;
      margin-right: auto;
      flex-direction: column;
    }

    article #introduction {
      padding: var(--size-l) 0 0;
    }
  }
</style>

<article class="m-t-xxxxl" id="rik">
  <div id="hero" class="push-s-1 col-s-2 col-l-3">
    <img src="static/images/rik-dekker.png" alt="Rik Dekker" />
  </div>

  <div class="p-l" id="introduction">
    <h1>
      Ik ben
      {@html '<strong>Rik Dekker</strong>,'}
      een
      <strong>freelance designer</strong>
      en
      <strong>developer</strong>
      uit
      {@html '<strong>Amsterdam</strong>.'}
    </h1>
    <p>
      Ik ontwerp en ontwikkel webapplicaties en websites met Python, Django,
      Wagtail en React. Voor een optimale gebruikerservaring zijn deze snel,
      responsive en gebruiksvriendelijk. Voor vindbaarheid maak ik gebruik van
      de laatste SEO-technieken.
    </p>
  </div>
</article>
